import React from "react";
import { useNavigate } from "react-router-dom";
import { BottomNav } from "@/components/BottomNav";
import { Logo } from "@/components/Logo";

export function AppShell({ children, showNav = true, right = null, onLogoClick }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-decide-canvas">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-decide-canvas/85 border-b border-decide-line/70">
        <div className="decide-shell flex items-center justify-between h-14">
          <button onClick={() => (onLogoClick ? onLogoClick() : navigate("/"))} aria-label="Home" data-testid="header-logo">
            <Logo size="sm" />
          </button>
          <div className="flex items-center gap-2">{right}</div>
        </div>
      </header>
      <main className={`decide-shell ${showNav ? "pb-28" : "pb-10"} pt-6`}>{children}</main>
      {showNav && <BottomNav />}
    </div>
  );
}
